export function getCombinationKey(branch?: string, client?: string): string {
  const safeBranch = branch?.trim() || 'Default';
  const safeClient = client?.trim() || '';
  return safeClient ? `${safeBranch}/${safeClient}` : safeBranch;
}

export function isDefaultCombination(combination: string): boolean {
  return combination === 'Default';
}

export function sortCombinationsDefaultFirst(combinations: string[]): string[] {
  return [...combinations].sort((a, b) => {
    const aDef = a === 'Default';
    const bDef = b === 'Default';
    if (aDef !== bDef) return aDef ? -1 : 1;
    return a.localeCompare(b);
  });
}

export function formatMarginPercentage(val: number | null): string {
  if (val === null) return 'N/A';
  return `${val.toFixed(2)}%`;
}
